function WriteOptDataArea(props: any) {
  let myProps = {
    corp_opt_data: {},
    set_corp_opt_data: (inData: any) => { },
    corp_info: {},
    refresh_data: () => { },
    ...props
  };
  let corp_opt_data = myProps.corp_opt_data;

  const handleInputChange = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    myProps.set_corp_opt_data({ ...corp_opt_data, [name]: value });
  };

  return (
    <div className="write-table-div mt-1">
      <table>
        <colgroup>
          <col width="160px"></col>
          <col width="*"></col>
        </colgroup>
        <tbody>
          <tr>
            <th>은행</th>
            <td>
              <input type="text" className="row-input" name="a_comp_account_bank" value={corp_opt_data.a_comp_account_bank}
                onChange={handleInputChange} placeholder="은행" autoComplete="off" />
            </td>
          </tr>
          <tr>
            <th>예금주</th>
            <td>
              <input type="text" className="row-input" name="a_comp_account_owner" value={corp_opt_data.a_comp_account_owner}
                onChange={handleInputChange} placeholder="예금주" autoComplete="off" />
            </td>
          </tr>
          <tr>
            <th>계좌번호</th>
            <td>
              <input type="text" className="row-input" name="a_comp_account_num" value={corp_opt_data.a_comp_account_num}
                onChange={handleInputChange} placeholder="계좌번호" autoComplete="off" />
            </td>
          </tr>
          {/* <tr>
            <th>자동청구서생성</th>
            <td>
              <select className="row-input" name="a_is_use_supply_sche" value={corp_opt_data.a_is_use_supply_sche}
                onChange={handleInputChange}>
                <option value="1">예</option>
                <option value="">아니오</option>
              </select>
            </td>
          </tr> */}
          <tr>
            <th>교재부모결제</th>
            <td>
              <select className="row-input" name="a_is_shop_order_payt_parent" 
                value={corp_opt_data.a_is_shop_order_payt_parent}
                style={{width:"100px"}}
                onChange={handleInputChange}>
                <option value="">아니오</option>
                <option value="1">예</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default WriteOptDataArea;